export default __webpack_public_path__ + "static/media/auth-screen-illustration-3.2f61e9ab.svg";